import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';

export default class HealthCheckApiService extends AbstractApiService {
  api_key: string | null = null;
  public constructor() {
    super({});
  }

  public async all(): Promise<dynamicObj> {
    const options = {
      error: this.handleServiceError.bind(this),
      headers: {},
    };

    return super.get(api.health_check, options);
  }

  protected handleServiceError(error: any): any {
    const message = error.message ?? 'service_down';
    const status =
      error.response && error.response.status ? error.response.status : 400;
    throw { status: status, message: message };
  }
}
